module.exports = __webpack_public_path__ + "fonts/iconfont.077dfa10.woff2";